import Layout from "@/components/layout/index.vue"
import Login from "@/pages/login/index.vue"

export default[
	{
		path:"/",
		component:Layout,
		redirect:"/home",
		children:[
			{
				path:"/home",
				name:"首页",
				meta:{index:0},
				component:()=>import("@/pages/home/total.vue"),
			},
			{
				path:"/perm",
				name:"菜单管理",
				meta:{index:0},
				component:()=>import("@/pages/sys/perm/perm.vue"),
			},
			{
				path:"/role",
				name:"角色管理",
				meta:{index:0},
				component:()=>import("@/pages/sys/role/role.vue"),
			},
			{
				path:"/role/add",
				name:"添加角色",
				meta:{index:0},
				component:()=>import("@/pages/sys/role/add.vue"),
			},
			{
				path:"/role/edit",
				name:"编辑角色",
				meta:{index:0},
				component:()=>import("@/pages/sys/role/edit.vue"),
			},
			{
				path:"/user",
				name:"用户管理",
				meta:{index:0},
				component:()=>import("@/pages/sys/user/user.vue"),
			},
			{
				path:"/derate",
				name:"催收减免",
				meta:{index:0},
				component:()=>import("@/pages/call/accountBook/derate.vue"),
			},
			{
				path:"/estimate",
				name:"7天预估",
				meta:{index:0},
				component:()=>import("@/pages/call/accountBook/estimate.vue"),
			},
			{
				path:"/daycall",
				name:"每日数据总览",
				meta:{index:0},
				component:()=>import("@/pages/call/accountBook/daycall.vue"),
			},
			{
				path:"/loan",
				name:"贷后整体数据",
				meta:{index:0},
				component:()=>import("@/pages/call/callreport/loan.vue"),
			},
			{
				path:"/callreport",
				name:"催回实时数据报表",
				meta:{index:0},
				component:()=>import("@/pages/call/callreport/index.vue"),
			},
			{
				path:"/log",
				name:"日志管理",
				meta:{index:0},
				component:()=>import("@/pages/sys/log/log.vue"),
			},
			{
				path:"/userlist",
				name:"am用户管理",
				meta:{index:0},
				component:()=>import("@/pages/userlist/user.vue"),
			},
			{
				path:"/orderInfo",
				name:"用户订单信息",
				meta:{index:0},
				component:()=>import("@/pages/userlist/orderInfo.vue"),
			},
			{
				path:"/userlist/extend",
				name:"用户认证信息",
				meta:{index:0},
				component:()=>import("@/pages/userlist/extend.vue"),
			},
			{
				path:"/callorder/call",
				name:"订单催收信息",
				meta:{index:0},
				component:()=>import("@/pages/callorder/call.vue"),
			},
			{
				path:"/repayment",
				name:"用户还款管理",
				meta:{index:0},
				component:()=>import("@/pages/repayment/index.vue"),
			},
			{
				path:"/superfluous",
				name:"用户多余还款数据列表",
				meta:{index:0},
				component:()=>import("@/pages/repayment/superfluous.vue"),
			},
			{
				path:"/rollover",
				name:"用户展期/逾期管理",
				meta:{index:0},
				component:()=>import("@/pages/rollover/index.vue"),
			},
			{
				path:"/externalorder",
				name:"外部订单管理",
				meta:{index:0},
				component:()=>import("@/pages/externalorder/index.vue"),
			},
			{
				path:"/product",
				name:"产品配置",
				meta:{index:0},
				component:()=>import("@/pages/sys/product/index.vue"),
			},
			{
				path:"/account",
				name:"账期配置",
				meta:{index:0},
				component:()=>import("@/pages/call/accountBook/index.vue"),
			},
			{
				path:"/classify",
				name:"催收分类配置",
				meta:{index:0},
				component:()=>import("@/pages/call/classify/index.vue"),
			},
			{
				path:"/smsconfig",
				name:"催收短信配置",
				meta:{index:0},
				component:()=>import("@/pages/call/sms/index.vue"),
			},
			{
				path:"/group",
				name:"小组配置",
				meta:{index:0},
				component:()=>import("@/pages/call/group/index.vue"),
			},
			{
				path:"/parameter",
				name:"系统参数配置",
				meta:{index:0},
				component:()=>import("@/pages/sys/parameter/index.vue"),
			},
			{
				path:"/limit",
				name:"额度配置",
				meta:{index:0},
				component:()=>import("@/pages/sys/limit/index.vue"),
			},
			{
				path:"/order",
				name:"订单列表",
				meta:{index:0},
				component:()=>import("@/pages/order/index.vue"),
			},
			{
				path:"/payError",
				name:"放款失败订单列表",
				meta:{index:0},
				component:()=>import("@/pages/order/payError.vue"),
			},
			{
				path:"/callorder",
				name:"催收订单",
				meta:{index:0},
				component:()=>import("@/pages/callorder/index.vue"),
			},
			{
				path:"/mycall",
				name:"我的催收订单",
				meta:{index:0},
				component:()=>import("@/pages/mycall/index.vue"),
			},
			{
				path:"/mycallnew",
				name:"我的催收订单-新",
				meta:{index:0},
				component:()=>import("@/pages/mycall/new.vue"),
			},
			{
				path:"/collmonitor",
				name:"催收员监控",
				meta:{index:0},
				component:()=>import("@/pages/mycall/collmonitor.vue"),
			},
			{
				path:"/mycallsucc",
				name:"我的催收成功订单",
				meta:{index:0},
				component:()=>import("@/pages/mycall/callsucc.vue"),
			},
			{
				path:"/mycallsuccyq",
				name:"我的催收成功逾期订单",
				meta:{index:0},
				component:()=>import("@/pages/mycall/callsuccyq.vue"),
			},
			{
				path:"/proofquery",
				name:"凭证查询",
				meta:{index:0},
				component:()=>import("@/pages/mycall/proofquery.vue"),
			},
			{
				path:"/callTotal",
				name:"在催统计",
				meta:{index:0},
				component:()=>import("@/pages/mycall/callTotal.vue"),
			},
			{
				path:"/channelAn",
				name:"投放渠道分析",
				meta:{index:0},
				component:()=>import("@/pages/bazaar/channelAn.vue"),
			},
			{
				path:"/complexPower",
				name:"复借率统计",
				meta:{index:0},
				component:()=>import("@/pages/bazaar/complexPower.vue"),
			},
			{
				path:"/callOldTotal",
				name:"在催历史统计",
				meta:{index:0},
				component:()=>import("@/pages/mycall/callOldTotal.vue"),
			},
			{
				path:"/queryDayDetail",
				name:"查看每天详情",
				meta:{index:0},
				component:()=>import("@/pages/mycall/queryDayDetail.vue"),
			},
			{
				path:"/labour",
				name:"人工推送",
				meta:{index:0},
				component:()=>import("@/pages/info/labour.vue"),
			},
			{
				path:"/push",
				name:"推送列表",
				meta:{index:0},
				component:()=>import("@/pages/info/push.vue"),
			},
			{
				path:"/plantilla",
				name:"消息模板",
				meta:{index:0},
				component:()=>import("@/pages/info/plantilla.vue"),
			},
			{
				path:"/usercheck",
				name:"用户信息审核",
				meta:{index:0},
				component:()=>import("@/pages/check/user.vue"),
			},
			{
				path:"/cardcheck",
				name:"身份证信息审核",
				meta:{index:0},
				component:()=>import("@/pages/check/card.vue"),
			},
			{
				path:"/ordercheck",
				name:"订单审核",
				meta:{index:0},
				component:()=>import("@/pages/check/order.vue"),
			},
			{
				path:"/calldetail",
				name:"在催历史统计详情",
				meta:{index:0},
				component:()=>import("@/pages/mycall/calldetail.vue"),
			},
			{
				path:"/changepass",
				name:"修改密码",
				meta:{index:0},
				component:()=>import("@/pages/sys/user/changepass.vue"),
			},
			{
				path:"/datamonitor",
				name:"数据监控",
				meta:{index:0},
				component:()=>import("@/pages/monitor/date.vue"),
			},
			{
				path:"/categor",
				name:"用户等级",
				meta:{index:0},
				component:()=>import("@/pages/monitor/categor.vue"),
			},
			{
				path:"/walky",
				name:"话机记录列表",
				meta:{index:0},
				component:()=>import("@/pages/walky/index.vue"),
			},
			{
				path:"/profit",
				name:"利润统计",
				meta:{index:0},
				component:()=>import("@/pages/mycall/profit.vue"),
			},
			{
				path: "/registerPay",
				name: "注册交易报表",
				meta: { index: 0 },
				component: () => import("@/pages/report/registerPay.vue"),
			},
			{
				path: "/registerPayNew",
				name: "注册交易报表-新",
				meta: { index: 0 },
				component: () => import("@/pages/report/registerPayNew.vue"),
			},
			{
				path: "/loanInfo",
				name: "放款报表",
				meta: { index: 0 },
				component: () => import("@/pages/report/loanInfo.vue"),
			},
			{
				path: "/dueDate",
				name: "到期日报表",
				meta: { index: 0 },
				component: () => import("@/pages/report/dueDate.vue"),
			},
			{
				path: "/reLending",
				name: "复贷报表",
				meta: { index: 0 },
				component: () => import("@/pages/report/reLending.vue"),
			},
			{
				path: "/telProfit",
				name: "利润报表",
				meta: { index: 0 },
				component: () => import("@/pages/report/profit.vue"),
			},
			{
				path: "/totalAdvert",
				name: "总广告分析报表",
				meta: { index: 0 },
				component: () => import("@/pages/report/totalAdvert.vue"),
			},
			{
				path: "/weekAdvert",
				name: "周广告分析报表",
				meta: { index: 0 },
				component: () => import("@/pages/report/weekAdvert.vue"),
			},
			{
				path:"/error/403",
				name:"无权限访问",
				meta:{index:15},
				component:()=>import("@/pages/error/403.vue"),
			},
			{
				path:"/error/500",
				name:"服务器错误",
				meta:{index:16},
				component:()=>import("@/pages/error/500.vue"),
			},
			{
				path:"/error/400",
				name:"400错误",
				meta:{index:16},
				component:()=>import("@/pages/error/400.vue"),
			},
		]
	},
	{
		path:"/login",
		name:"登录",
		component:Login,
	}
	
]



